<template>
  <div>
    <div class="row my-1">
      <div class="offset-4 col-8 d-flex">
        <input v-model="startDate" class="form-control form-control-sm mx-2" type="date">
        <input v-model="endDate" class="form-control form-control-sm mx-2" type="date">
        <button
          @click="$parent.getAccessStats(startDate, endDate)"
          class="btn btn-sm btn-outline-info float-right mr-2"
        >Харах</button>
        <button
          @click="$parent.onDownloadExcel('access_stat_excel', startDate, endDate)"
          class="btn btn-sm btn-outline-success"
        >Excel татах</button>
      </div>
    </div>
    <h1 class="stat__title">Хандалтын статистик</h1>
    <bar-chart v-if="hasAccessStat" :data="this.userStats" :stacked="true" class="stat-box"/>
    <div v-else class="text-secondary text-center">
      <i class="fas fa-exclamation-circle"></i>
      Өгөгдөл олдсонгүй
    </div>
    <br>
    <h1 class="stat__title">Хандалтын статистик (девайс тус бүрээр)</h1>
    <bar-chart
      v-if="hasAccessStatTerminal"
      :data="this.terminalStats"
      :stacked="false"
      class="stat-box"
    />
    <div v-else class="text-secondary text-center">
      <i class="fas fa-exclamation-circle"></i>
      Өгөгдөл олдсонгүй
    </div>
    <br>
    <h1 class="stat__title">Хэрэглэгчийн статистик</h1>
    <bar-chart v-if="hasUserStat" :data="this.countStats" :stacked="false" class="stat-box"/>
    <div v-else class="text-secondary text-center">
      <i class="fas fa-exclamation-circle"></i>
      Өгөгдөл олдсонгүй
    </div>
    <br>
    <h1 class="stat__title">Хэрэглэгчийн статистик (девайс тус бүрээр)</h1>
    <bar-chart
      v-if="hasUserStatTerminal"
      :data="this.terminalUniqueStats"
      :stacked="false"
      class="stat-box"
    />
    <div v-else class="text-secondary text-center">
      <i class="fas fa-exclamation-circle"></i>
      Өгөгдөл олдсонгүй
    </div>
    <br>
    <h1 class="stat__title">Хандалтын статистик (цаг тус бүрээр)</h1>
    <bar-chart v-if="hasTimeStat" :data="this.timeStats" :stacked="false" class="stat-box"/>
    <div v-else class="text-secondary text-center">
      <i class="fas fa-exclamation-circle"></i>
      Өгөгдөл олдсонгүй
    </div>
  </div>
</template>

<style>
.stat__title {
  font-weight: 600;
  font-size: 18px;
  color: #777;
  margin-left: 15px;
}
</style>


<script>
import BarChart from "@/components/chart/BarChart";

export default {
  name: "UserAccess",

  components: { BarChart },

  props: ["accessStat", "start", "end"],

  watch: {
    accessStat: function() {
      this.makeData();
    }
  },

  created() {
    this.makeData();
  },

  computed: {
    hasAccessStat: function() {
      return (
        this.accessStat.stat.unloggedAccess != null &&
        this.accessStat.stat.loggedAccess != null
      );
    },

    hasAccessStatTerminal: function() {
      return (
        this.accessStat.stat.PC != null &&
        this.accessStat.stat.IOS != null &&
        this.accessStat.stat.ANDROID != null
      );
    },

    hasUserStat: function() {
      return (
        this.accessStat.stat.userCount != null &&
        this.accessStat.stat.tokenCount != null
      );
    },

    hasUserStatTerminal: function() {
      return (
        this.accessStat.stat.PC_unique != null &&
        this.accessStat.stat.IOS_unique != null &&
        this.accessStat.stat.ANDROID_unique != null
      );
    },

    hasTimeStat: function() {
      return (
        this.accessStat.stat.time != null &&
        this.accessStat.stat.time.length > 0
      );
    }
  },

  data() {
    return {
      userStats: null,
      countStats: null,
      terminalStats: null,
      terminalUniqueStats: null,
      timeStats: null,

      startDate: this.start,
      endDate: this.end
    };
  },

  methods: {
    makeData() {
      this.userStats = this.hasAccessStat
        ? this.makeStatsData(this.accessStat, [
            {
              name: "unloggedAccess",
              displayName: "Нэвтрээгүй хандалт",
              color: "#800000"
            },
            {
              name: "loggedAccess",
              displayName: "Нэвтэрсэн хандалт",
              color: "#000080"
            }
          ])
        : null;

      this.countStats = this.hasUserStat
        ? this.makeStatsData(this.accessStat, [
            {
              name: "userCount",
              displayName: "Нэвтэрсэн хэрэглэгч",
              color: "#C71585"
            },
            {
              name: "tokenCount",
              displayName: "Нийт хэрэглэгч",
              color: "#536543"
            }
          ])
        : null;

      this.terminalStats = this.hasAccessStatTerminal
        ? this.makeStatsData(this.accessStat, [
            { name: "PC", displayName: "Компьютер хандалт", color: "#f87979" },
            {
              name: "ANDROID",
              displayName: "Android хандалт",
              color: "#a87979"
            },
            { name: "IOS", displayName: "IOS хандалт", color: "#4682B4" }
          ])
        : null;

      this.terminalUniqueStats = this.hasUserStatTerminal
        ? this.makeStatsData(this.accessStat, [
            {
              name: "PC_unique",
              displayName: "Компьютер хэрэглэгч",
              color: "#f87979"
            },
            {
              name: "ANDROID_unique",
              displayName: "Android хэрэглэгч",
              color: "#a87979"
            },
            {
              name: "IOS_unique",
              displayName: "IOS хэрэглэгч",
              color: "#4682B4"
            }
          ])
        : null;

      if (this.hasTimeStat) {
        this.timeStats = {
          labels: [],
          datasets: []
        };
        let dataset = {
          label: "Хандалтын тоо",
          type: "line",
          data: [],
          lineTension: 0,
          backgroundColor: "#00640040",
          borderColor: "#006400",
          borderWidth: 1
        };
        this.accessStat.stat.time.forEach(time => {
          this.timeStats.labels.push(time.statName);
          dataset.data.push(time.count);
        });
        this.timeStats.datasets.push(dataset);
      } else this.timeStats = null;
    },

    makeStatsData(response, charts) {
      let stats = {};
      let dates = this.getDates(
        new Date(response.startDate),
        new Date(response.endDate)
      );

      stats.labels = dates; //labels set

      let stat = response.stat;

      let datasets = [];

      charts.forEach(chart => {
        let dataset = {};
        dataset.label = chart.displayName;
        dataset.backgroundColor = chart.color;
        dataset.data = [];
        dates.forEach(date => {
          let index = this.searchByDate(stat[chart.name], date);
          dataset.data.push(index > -1 ? stat[chart.name][index].count : null);
        });
        datasets.push(dataset);
      });

      stats.datasets = datasets; //datasets set

      return stats;
    },

    getDates(startDate, endDate) {
      var dates = [],
        currentDate = startDate,
        addDays = function(days) {
          var date = new Date(this.valueOf());
          date.setDate(date.getDate() + days);
          return date;
        };
      while (currentDate <= endDate) {
        dates.push(currentDate.toISOString().split("T")[0]);
        currentDate = addDays.call(currentDate, 1);
      }
      return dates;
    },

    searchByDate(objArr, date) {
      return objArr.map(x => x.accessDate).indexOf(date);
    }
  }
};
</script>